import React, { useEffect, useState } from "react";
import axios from "axios";

const SportsAndStudents = ({ backEndUrl }) => {
    const [studentAthleticDetails, setStudentAthleticDetails] = useState([]);
    const [students, setStudents] = useState([]);
    const [sports, setSports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchDataFromBackend = async () => {
            try {
                setLoading(true);
                // Call backend service to fetch combined data
                const response = await axios.get(`${backEndUrl}/sportsAndStudents`);
                const data = response.data;

                setStudentAthleticDetails(data.studentAthleticDetails || []);
                setStudents(data.students || []);
                setSports(data.sports || []);
            } catch (err) {
                setError("Failed to fetch data from backend.");
            } finally {
                setLoading(false);
            }
        };

        fetchDataFromBackend();
    }, [backEndUrl]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    // Organize students by sport
    const sportsMap = {};
    studentAthleticDetails.forEach(detail => {
        const sport = sports.find(s => s.Id === detail.SportId);
        const student = students.find(s => s.Id === detail.StudentId);
        if (sport && student) {
            if (!sportsMap[sport.Name]) {
                sportsMap[sport.Name] = [];
            }
            sportsMap[sport.Name].push(`${student.FirstName} ${student.LastName} (${student.StudentNumber})`);
        }
    });

    return (
        <div className="sports-students-container">
            <h2>Student Athletic Details</h2>
            <table>
                <thead>
                <tr>
                    <th>Sport</th>
                    <th>Students</th>
                </tr>
                </thead>
                <tbody>
                {Object.entries(sportsMap).map(([sportName, studentNames], index) => (
                    <tr key={index}>
                        <td>{sportName}</td>
                        <td>{studentNames.join(", ")}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default SportsAndStudents;
